<template>
  <div class="file-upload-classic" :class="rootClass">
    <div class="d-flex align-center">
      <!-- column 1 -->
      <img
        v-if="lastValidFile"
        :src="lastValidFile.thumbnail"
        :alt="lastValidFile.fileName"
      />

      <v-btn
        key="btn-upload"
        v-show="!lastValidFile"
        depressed
        class="dropzone-clickable primary--text"
        :disabled="disabled"
      >
        <v-icon left>mdi-upload</v-icon>
        Select File
      </v-btn>

      <!-- column 2 -->
      <div class="ml-4 file-upload-classic--title" v-if="!lastValidFile">
        No file chosen
      </div>
      <div class="ml-4 file-upload-classic--title" v-else-if="!disabled">
        {{ lastValidFile.fileName }}
      </div>

      <!-- column 3 -->
      <v-btn
        key="btn-remove"
        v-if="lastValidFile && !disabled"
        icon
        class="ml-4"
        @click="file = null"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <div v-if="!disabled" class="file-upload-classic--description mt-3">
      <span
        v-if="acceptedFileTypePrefixes && acceptedFileTypePrefixes.length === 1"
      >
        Accepted {{ acceptedFileTypePrefixes[0] }} formats:
        {{ acceptedFileNames }}.
      </span>
      <span v-else> Accepted {{ acceptedFileNames }} only. </span>
      {{ maxFilesizeStr && `Max size of ${maxFilesizeStr}` }}
    </div>
  </div>
</template>

<script>
import BaseFileUpload from "@/mixins/base-fileupload";
export default {
  name: "FileUploadClassic",
  mixins: [BaseFileUpload],
  props: {
    existingFile: Object
  },
  data: () => ({
    file: null
  }),
  watch: {
    existingFile: {
      immediate: true,
      handler(file) {
        if (!file) this.file = null;
        else if (!this.file || this.file.uploadId !== file.id) {
          this.file = {
            id: file.id,
            uploadId: file.id,
            fileName: file.fileName,
            thumbnail: file.previewUrl,
            status: file.status || "success"
          };
        }
      }
    }
  },
  computed: {
    // this is to normalize state so we can reuse stuff from base mixin
    files() {
      return this.file ? [this.file] : [];
    }
  },
  methods: {
    addFile(file) {
      this.file = file;
    }
  }
};
</script>

<style lang="sass" scoped>
.file-upload-classic
  &--title
    font-size: 1rem
  &--description
    font-size: 0.75rem
</style>
